<template>
  <!-- 系统字段country列表 -->
  <a-select
    v-if="data.systemType === '1'"
    v-model:value="selectValue"
    style="width: 100%"
    :options="countryList"
    :disabled="disabled"
    :field-names="{ label: 'countryName', value: 'countryCode' }"
    :placeholder="$t('ep_admin_tips_select')"
    :getPopupContainer="triggerNode => triggerNode.parentNode.parentNode"
    @change="e => handleChange(e, 'country')"
    showSearch
    allowClear
  ></a-select>
  <!-- 系统字段state列表 -->
  <a-select
    v-if="data.systemType === '2'"
    v-model:value="selectValue"
    style="width: 100%"
    :options="stateList"
    :disabled="disabled"
    :field-names="{ label: 'provinceName', value: 'provinceCode' }"
    :placeholder="$t('ep_admin_tips_select')"
    :getPopupContainer="triggerNode => triggerNode.parentNode.parentNode"
    @change="e => handleChange(e, 'state')"
    allowClear
  ></a-select>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import { GetCountryList, GetStateList } from '@/services/marketing-management/form-management'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: [String, Number],
    default: undefined
  },
  countryValue: {
    required: false,
    type: String,
    default: undefined
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['update:value', 'change'])
const selectValue = ref(props.value)
const countryList = ref([])
const stateList = ref([])

// 暂定入参
const handleChange = (value: any, type: string) => {
  emit('update:value', value)
  if (type === 'country') {
    emit('change', value)
  }
}

const getStateList = async (val: any) => {
  const { data } = (await GetStateList({ countryCode: val })) || []
  stateList.value = data
  if (selectValue.value) {
    const result = stateList.value.some(item => item.provinceCode == selectValue.value)
    if (!result) {
      selectValue.value = undefined
      handleChange(undefined, '')
    }
  }
}

watch(
  () => props.countryValue,
  value => {
    if (props.data.systemType === '2') {
      if (props.countryValue) {
        getStateList(props.countryValue)
      } else {
        stateList.value = []
      }
    }
  }
)

onMounted(async () => {
  if (props.data.systemType === '1') {
    const { data } = await GetCountryList()
    countryList.value = data
    if (props.data.fieldValue) {
      handleChange(props.data.fieldValue, 'country')
    }
  }
})
</script>
